/**
 * auth页面参数解析器
 */
import conf from '../../conf/wx.conf'
import { getObjectByUrlParams } from '../../utils/tools'

class AuthParamsParser {
  constructor () {
    this.state = 'none'
    this.result = {}
  }

  setParams (params) {
    const stateParams = getObjectByUrlParams(params.state, conf.STATE_JOIN_CHAR)
    if (stateParams) this.result.state = stateParams

    if (params.code) {
      this.result.code = params.code
      this.state = 'isGetToken'
    } else {
      this.result = params
      this.state = 'isRefreshToken'
    }
    return this
  }

  isGetToken (cb) {
    this.state === 'isGetToken' && cb(this.result)
    return this
  }

  isRefreshToken (cb) {
    this.state === 'isRefreshToken' && cb(this.result)
    return this
  }
}

export default AuthParamsParser
